import * as React from 'react';

import { WizardStepsActionType, WizardStepsContextType, WizardStepsState } from './types';
import { wizardStepsReducer } from './wizardStepsReducer';

const WizardStepsContext = React.createContext<WizardStepsContextType | null>(null);
WizardStepsContext.displayName = 'WizardStepsContext';

export const useWizardSteps = () => {
  const context = React.useContext(WizardStepsContext);
  if (!context) {
    throw new Error(`Element cannot be used outside of WizardStepsProvider`);
  }
  return context;
};

export const WizardStepsProvider = ({
  children,
  initialState,
}: {
  initialState: WizardStepsState;
  children: React.ReactNode;
}) => {
  const [wizardState, dispatch] = React.useReducer(wizardStepsReducer, initialState);
  const value = React.useMemo(() => {
    return {
      nextStep: (currentStepName: string) =>
        dispatch({ payload: { currentStepName }, type: WizardStepsActionType.NEXT_STEP }),
      openStep: (stepName: string) => dispatch({ payload: { stepName }, type: WizardStepsActionType.OPEN_STEP }),
      getStep: (stepName: string) => wizardState.steps[stepName],
    };
  }, [wizardState]);

  return <WizardStepsContext.Provider value={value}>{children}</WizardStepsContext.Provider>;
};
